// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const CentosIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 48 48">
    <g clipPath="url(#centos_svga)">
      <path
        fill="#932279"
        fillRule="evenodd"
        d="m20.32 22.29 1.7 1.7-1.7 1.7H8.3v5.68L.96 23.99l7.34-7.26v5.56z"
        clipRule="evenodd"
      />
      <path
        fill="#EFA724"
        fillRule="evenodd"
        d="m25.67 20.34-1.7 1.7-1.7-1.7V8.32h-5.68L23.97.98l7.26 7.34h-5.56z"
        clipRule="evenodd"
      />
      <path
        fill="#262577"
        fillRule="evenodd"
        d="m27.75 25.74-1.7-1.7 1.7-1.7h12.02v-5.67l7.33 7.37-7.33 7.26v-5.56z"
        clipRule="evenodd"
      />
      <path
        fill="#9CCD2A"
        fillRule="evenodd"
        d="m22.33 27.67 1.7-1.7 1.7 1.7v12.02h5.67l-7.37 7.34-7.26-7.34h5.56z"
        clipRule="evenodd"
      />
      <path
        fill="#9CCD2A"
        stroke="#fff"
        strokeMiterlimit={4.25}
        strokeWidth={1.11}
        d="M7.86 7.88h14.57v14.57H7.86z"
      />
      <path
        fill="#932279"
        stroke="#fff"
        strokeMiterlimit={4.25}
        strokeWidth={1.11}
        d="M25.51 7.88H40.1v14.57H25.5z"
      />
      <path
        fill="#EFA724"
        stroke="#fff"
        strokeMiterlimit={4.25}
        strokeWidth={1.11}
        d="M25.51 25.54H40.1V40.1H25.5z"
      />
      <path
        fill="#262577"
        stroke="#fff"
        strokeMiterlimit={4.25}
        strokeWidth={1.11}
        d="M7.86 25.54h14.57V40.1H7.86z"
      />
      <path
        stroke="#fff"
        strokeMiterlimit={4.25}
        strokeWidth={1.11}
        d="m1.16 23.99 10.32-10.32 10.31 10.32L11.48 34.3zM13.7 11.54 24.04 1.22l10.31 10.32-10.31 10.32zM26.15 23.99l10.32-10.32 10.32 10.32L36.47 34.3zM13.7 36.54l10.33-10.32 10.31 10.32-10.31 10.32z"
      />
    </g>
    <defs>
      <clipPath id="centos_svga">
        <path fill="#fff" d="M0 0h48v48H0z" />
      </clipPath>
    </defs>
  </svg>,
  "Centos",
);
export default CentosIcon;
